import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { HoverBox } from '../hoverBox/HoverBox';

export const OrderLine = ({ order, size, scaleY, portalRef }) => {
  return (
    <>
      {scaleY ? (
        <>
          <line
            stroke={colors.green}
            strokeWidth={1}
            x1={0}
            x2={size}
            y1={scaleY(order.price)}
            y2={scaleY(order.price)}
          />
          <HoverBox
            json={{
              Category: 'Order',
              Price: order.price,
              Quantity: order.quantity,
              Type: order.type,
            }}
            topBoundary={scaleY(order.price) - 2}
            bottomBoundary={scaleY(order.price) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
            size={size}
          />
        </>
      ) : null}
    </>
  );
};

OrderLine.propTypes = {
  order: PropTypes.shape({
    price: PropTypes.number,
    quantity: PropTypes.number,
    type: PropTypes.string,
  }),
  scaleY: PropTypes.func,
  size: PropTypes.number,
  portalRef: PropTypes.object,
};
